module.exports = __webpack_public_path__ + "static/John-Herb-631c0f0d81fc78df35b22d8c1d8d3900.jpg";